import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";

export default function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="forbidden-page">
      <ShieldX className="h-12 w-12 text-rose-500" />
      <h1 className="mt-4 font-display text-3xl font-bold">Akses Ditolak</h1>
      <p className="text-slate-500 mt-2 max-w-md">Anda tidak memiliki kewenangan untuk mengakses halaman atau menjalankan tindakan ini.</p>
      <Button onClick={() => navigate("/dasbor")} className="mt-6 bg-slate-900 hover:bg-slate-800 text-white">Kembali ke Dasbor</Button>
    </div>
  );
}
